import * as yup from 'yup';

export const bucketValidationSchema = yup.object({
  name: yup
    .string()
    .required('Bucket name is required')
    .max(100, 'Bucket name must be less than 100 characters')
    .matches(/^[a-zA-Z0-9\s-_]+$/, 'Bucket name can only contain letters, numbers, spaces, hyphens, and underscores'),
  path: yup
    .string()
    .required('Path is required')
    .max(200, 'Path must be less than 200 characters')
    .matches(/^\/[a-zA-Z0-9/\s-_]*$/, 'Path must start with a forward slash (/) and contain only valid characters'),
  assigned_user: yup
    .number()
    .required('A user must be assigned to this bucket')
    .positive('User ID must be a positive number'),
});

export const bucketUpdateValidationSchema = yup.object({
  name: yup
    .string()
    .max(100, 'Bucket name must be less than 100 characters')
    .matches(/^[a-zA-Z0-9\s-_]+$/, 'Bucket name can only contain letters, numbers, spaces, hyphens, and underscores'),
  path: yup
    .string()
    .max(200, 'Path must be less than 200 characters')
    .matches(/^\/[a-zA-Z0-9/\s-_]*$/, 'Path must start with a forward slash (/) and contain only valid characters'),
  assigned_user: yup.number().positive('User ID must be a positive number'),
});

export const userAssignmentValidationSchema = yup.object({
  userId: yup.number().required('User ID is required').positive('User ID must be a positive number'),
  bucketId: yup.number().required('Bucket ID is required').positive('Bucket ID must be a positive number'),
});

export const validateBucketName = (name) => {
  const errors = [];

  if (!name || name.trim().length === 0) {
    errors.push('Bucket name is required');
  } else {
    if (name.length > 100) {
      errors.push('Bucket name must be less than 100 characters');
    }

    if (!/^[a-zA-Z0-9\s-_]+$/.test(name)) {
      errors.push('Bucket name can only contain letters, numbers, spaces, hyphens, and underscores');
    }
  }

  return errors;
};

export const validateBucketPath = (path) => {
  const errors = [];

  if (!path || path.trim().length === 0) {
    errors.push('Path is required');
  } else {
    if (path.length > 200) {
      errors.push('Path must be less than 200 characters');
    }

    if (!path.startsWith('/')) {
      errors.push('Path must start with a forward slash (/)');
    }

    if (!/^\/[a-zA-Z0-9/\s-_]*$/.test(path)) {
      errors.push('Path contains invalid characters');
    }
  }

  return errors;
};

export const validateUserAssignment = (userId, bucketId, users, buckets) => {
  const errors = [];

  if (!userId) {
    errors.push('User ID is required');
  } else {
    const user = users.find((u) => u.id === userId);
    if (!user) {
      errors.push('User not found');
    } else if (user.assignedBucket) {
      errors.push('User is already assigned to a bucket');
    }
  }

  if (!bucketId) {
    errors.push('Bucket ID is required');
  } else {
    const bucket = buckets.find((b) => b.id === bucketId);
    if (!bucket) {
      errors.push('Bucket not found');
    } else if (bucket.assignedUser) {
      errors.push('Bucket is already assigned to a user');
    }
  }

  return errors;
};

export const validateStorageSize = (sizeString) => {
  const errors = [];

  if (!sizeString || sizeString.trim().length === 0) {
    errors.push('Storage size is required');
  } else {
    const sizeRegex = /^(\d+(?:\.\d+)?)\s*(B|KB|MB|GB|TB)$/i;
    if (!sizeRegex.test(sizeString)) {
      errors.push('Storage size must be in format: number followed by unit (B, KB, MB, GB, TB)');
    }
  }

  return errors;
};

export const validateBucketData = (bucketData) => {
  const errors = {};

  const nameErrors = validateBucketName(bucketData.name);
  if (nameErrors.length > 0) {
    errors.name = nameErrors[0];
  }

  const pathErrors = validateBucketPath(bucketData.path);
  if (pathErrors.length > 0) {
    errors.path = pathErrors[0];
  }

  if (!bucketData.assigned_user) {
    errors.assigned_user = 'A user must be assigned to this bucket';
  }

  return errors;
};

export const validateUniqueBucketName = (name, buckets, excludeId = null) => {
  const existingBucket = buckets.find(
    (bucket) => bucket.name.toLowerCase() === name.toLowerCase() && bucket.id !== excludeId
  );

  return existingBucket ? 'A bucket with this name already exists' : null;
};

export const validateUniqueBucketPath = (path, buckets, excludeId = null) => {
  const existingBucket = buckets.find(
    (bucket) => bucket.path.toLowerCase() === path.toLowerCase() && bucket.id !== excludeId
  );

  return existingBucket ? 'A bucket with this path already exists' : null;
};
